module.exports = __webpack_public_path__ + "static/media/autoprefixer.40d926c4.svg";